import { Energiattest, EnergyPlan } from '../../types/building';
import { Energimerke, Energimerkeversjon } from '../../types/energimerke';

export const getEnergimerkeversjon = (energiplan?: Partial<EnergyPlan>) =>
  // We support both keys while old data and mixed deployments may still return lowercase casing.
  {
    return (
      energiplan?.energimerke?.properties?.energimerkeVersjon ||
      energiplan?.energimerke?.properties?.energimerkeversjon ||
      Energimerkeversjon.V2025
    );
  };

export const fromEnergiplanToEnergimerke = (energiplan?: Partial<EnergyPlan>): Energimerke => ({
  energikarakter: energiplan?.energimerke?.energiKarakter,
  oppvarmingskarakter: energiplan?.energimerke?.properties?.oppvarmingKarakter,
  version: getEnergimerkeversjon(energiplan)
});

//TODO: Update data structure delivered from backend. We should not derive version from oppvarmingsKarakter.
export const fromAttestToEnergimerke = (attest?: Energiattest) => ({
  energikarakter: attest?.energiKarakter,
  oppvarmingskarakter: attest?.oppvarmingKarakter,
  version: attest?.oppvarmingKarakter ? Energimerkeversjon.V2023 : Energimerkeversjon.V2025
});
